import styled from "styled-components";
import {Image, Space} from "antd";
import {LockFilled} from "@ant-design/icons";

export const ProofImage = styled(Image)`
    height: 200px;
    width: 470px;
    max-width: 100%;
    object-fit: cover;
`;

export const InfoSpace = styled(Space)`
    display: flex;
`;

export const LockContainer = styled.div`
    display: flex;
    justify-content: center;
    background-color: #ededed;
    align-items: center;
    height: 200px;
    width: 100%;
`;

export const LockIcon = styled(LockFilled)`
    font-size: 150px;
    color: lightgrey;
`;
